export interface Person {
  f_name: string; //"نام"
  l_name: string; //"نام خانوادگی"
  birthdate: string; //"تاریخ تولد"
  education: string; //"سطح تحصیلات"
  job?: string; //"شغل"
  sex: number; //"جنسیت"
  marital_status: number; //"وضعیت تأهل"
  mobile: string; //"شماره همراه"
  messenger_mobile?: string; //"شماره پیامرسان"
  message_receiving: string; //"نحوه دریافت پیام"
  introduction: string; //"نحوه آشنایی"
  do_advertising?: number; //"گسترش فرهنگ صلوات"
  salavat_num: number; //"تعداد صلوات روزانه"
  team_leader?: number; //"تمایل به سرگروهی"
  state: string; //"استان"
  city: string; //"شهر"
  neighborhood: string; //"محله"
  region_num?: string; //"شماره منطقه"
  exact_address?: string; //"جزئیات آدرس"
  hamyari_1?: boolean; //"همیاری حمل و نقل"
  hamyari_2?: boolean; //"همیاری مراسمات"
  hamyari_3?: boolean; //"همیاری نیروی اجرایی"
  hamyari_4?: boolean; //"همیاری مهارت فنی"
  hamyari_5?: boolean; //"همیاری آشپزی"
  hamyari_6?: boolean; //"فرهنگی مربی کودکان"
  hamyari_7?: boolean; //"فرهنگی فعالیت قرآنی"
  hamyari_8?: boolean; //"فرهنگی تربیتی"
  hamyari_9?: boolean; //"فرهنگی آموزش و تدریس"
  hamyari_10?: boolean; //"همیاری کارآفرینی"
  hamyari_11?: boolean; //"همیاری محیط و فضا"
  hamyari_12?: boolean; //"همیاری مالی"
  hamyari_13?: boolean; //"همیاری اعتباری"
  hamyari_14?: boolean; //"همیاری گرافیک و تدوین"
  hamyari_15?: boolean; //"همیاری رسانه"
  hamyari_16?: boolean; //"همیاری هنر"
  hamyari_17?: boolean; //"همیاری بهداشت و درمان"
  hamyari_18?: boolean; //"همیاری مشاوره خانواده و روانشناسی"
  hamyari_19?: boolean; //"همیاری پژوهشی"
  hamyari_20?: boolean; //"سایر همیاری"
  explain?: string; //"توضیحات"
}

export function getDefaultPerson(): Person {
  return {
    f_name: "",
    l_name: "",
    birthdate: new Date(
      new Date().getUTCFullYear() - 20,
      new Date().getMonth(),
      new Date().getDate()
    ).toISOString(),
    education: "",
    sex: undefined,
    marital_status: undefined,
    mobile: "",
    message_receiving: "ایتا",
    introduction: "",
    salavat_num: undefined,
    state: "",
    city: "",
    neighborhood: "",

    hamyari_1: false,
    hamyari_2: false,
    hamyari_3: false,
    hamyari_4: false,
    hamyari_5: false,
    hamyari_6: false,
    hamyari_7: false,
    hamyari_8: false,
    hamyari_9: false,
    hamyari_10: false,
    hamyari_11: false,
    hamyari_12: false,
    hamyari_13: false,
    hamyari_14: false,
    hamyari_15: false,
    hamyari_16: false,
    hamyari_17: false,
    hamyari_18: false,
    hamyari_19: false,
    hamyari_20: false,
  };
}
